export const CRM_DATE_FORMAT = "YYYY-MM-DD";
export const COMMON_DATE_FORMAT = "DD-MMM-yyyy";

export const CONTRACT_RECORD_TYPE = [
  { label: "New Sale", value: "S" },
  { label: "Cancellation", value: "C" },
];

export const PRODUCT_QUALITY = [
  { label: "New", value: "N" },
  { label: "Refurbished", value: "R" },
];

export const CANCELLATION_REASONS = [
  { label: "File/API Request", value: "File/API Request" },
  { label: "Entered in Error", value: "Entered in Error" },
  { label: "Duplicate Entry", value: "Duplicate Entry" },
  { label: "Store out of Business", value: "Store out of Business" },
  {
    label: "Merchandised was returned/exchanged",
    value: "Merchandised was returned/exchanged",
  },
  { label: "Wrong Program SKU", value: "Wrong Program SKU" },
  { label: "Uncovered Product", value: "Uncovered Product" },
  {
    label: "Customer Changed Their Mind",
    value: "Customer Changed Their Mind",
  },
  {
    label: "Product Lost in Shipment/Never Delivered",
    value: "Product Lost in Shipment/Never Delivered",
  },
];

export const SUPPORT_REQUEST_OPTIONS = [
  { label: "Plan Cancellations", value: "Plan Cancellations" },
  { label: "General Inquiries", value: "General Inquiries" },
  { label: "Customer Inquiries", value: "Customer Inquiries" },
  { label: "Pro-rata Refunds", value: "Pro-rata Refunds" },
  { label: "Service Inquiries", value: "Service Inquiries" },
  { label: "General", value: "General" },
  { label: "Urgent", value: "Urgent" },
  { label: "Escalation", value: "Escalation" },
];

export const DEALER_PLAN_TYPE = [
  "DCAM10002YR",
  "DCAM12502YR",
  "DCAM15002YR",
  "DCAM20002YR",
  "DCAM25002YR",
  "DCAM30002YR",
  "DCAM35002YR",
  "DCAM40002YR",
  "DCAM45002YR",
  "DCAM50002YR",
  "DCAM60002YR",
  "DCAM70002YR",
  "DCAM80002YR",
  "DCAM90002YR",
  "DCAM10K2YR",
  "DCAM10002YRADH",
  "DCAM12502YRADH",
  "DCAM15002YRADH",
  "DCAM20002YRADH",
  "DCAM25002YRADH",
  "DCAM30002YRADH",
  "DCAM35002YRADH",
  "DCAM40002YRADH",
  "DCAM45002YRADH",
  "DCAM50002YRADH",
  "DCAM60002YRADH",
  "DCAM70002YRADH",
  "DCAM80002YRADH",
  "DCAM90002YRADH",
  "DCAM10K2YRADH",
  "DCAM10003YR",
  "DCAM12503YR",
  "DCAM15003YR",
  "DCAM20003YR",
  "DCAM25003YR",
  "DCAM30003YR",
  "DCAM35003YR",
  "DCAM40003YR",
  "DCAM45003YR",
  "DCAM50003YR",
  "DCAM60003YR",
  "DCAM70003YR",
  "DCAM80003YR",
  "DCAM90003YR",
  "DCAM10K3YR",
  "DCAM10003YRADH",
  "DCAM12503YRADH",
  "DCAM15003YRADH",
  "DCAM20003YRADH",
  "DCAM25003YRADH",
  "DCAM30003YRADH",
  "DCAM35003YRADH",
  "DCAM40003YRADH",
  "DCAM45003YRADH",
  "DCAM50003YRADH",
  "DCAM60003YRADH",
  "DCAM70003YRADH",
  "DCAM80003YRADH",
  "DCAM90003YRADH",
  "DCAM10K3YRADH",
  "DLENS3002YR",
  "DLENS4002YR",
  "DLENS5002YR",
  "DLENS7502YR",
  "DLENS10002YR",
  "DLENS12502YR",
  "DLENS15002YR",
  "DLENS20002YR",
  "DLENS25002YR",
  "DLENS30002YR",
  "DLENS35002YR",
  "DLENS40002YR",
  "DLENS45002YR",
  "DLENS50002YR",
  "DLENS60002YR",
  "DLENS70002YR",
  "DLENS80002YR",
  "DLENS90002YR",
  "DLENS10K2YR",
  "DLENS15K2YR",
  "DLENS20K2YR",
  "DLENS3002YRADH",
  "DLENS4002YRADH",
  "DLENS5002YRADH",
  "DLENS7502YRADH",
  "DLENS10002YRADH",
  "DLENS12502YRADH",
  "DLENS15002YRADH",
  "DLENS20002YRADH",
  "DLENS25002YRADH",
  "DLENS30002YRADH",
  "DLENS35002YRADH",
  "DLENS40002YRADH",
  "DLENS45002YRADH",
  "DLENS50002YRADH",
  "DLENS60002YRADH",
  "DLENS70002YRADH",
  "DLENS80002YRADH",
  "DLENS90002YRADH",
  "DLENS10K2YRADH",
  "DLENS15K2YRADH",
  "DLENS20K2YRADH",
  "DLENS3003YR",
  "DLENS4003YR",
  "DLENS5003YR",
  "DLENS7503YR",
  "DLENS10003YR",
  "DLENS12503YR",
  "DLENS15003YR",
  "DLENS20003YR",
  "DLENS25003YR",
  "DLENS30003YR",
  "DLENS35003YR",
  "DLENS40003YR",
  "DLENS45003YR",
  "DLENS50003YR",
  "DLENS60003YR",
  "DLENS70003YR",
  "DLENS80003YR",
  "DLENS90003YR",
  "DLENS10K3YR",
  "DLENS15K3YR",
  "DLENS20K3YR",
  "DLENS3003YRADH",
  "DLENS4003YRADH",
  "DLENS5003YRADH",
  "DLENS7503YRADH",
  "DLENS10003YRADH",
  "DLENS12503YRADH",
  "DLENS15003YRADH",
  "DLENS20003YRADH",
  "DLENS25003YRADH",
  "DLENS30003YRADH",
  "DLENS35003YRADH",
  "DLENS40003YRADH",
  "DLENS45003YRADH",
  "DLENS50003YRADH",
  "DLENS60003YRADH",
  "DLENS70003YRADH",
  "DLENS80003YRADH",
  "DLENS90003YRADH",
  "DLENS10K3YRADH",
  "DLENS15K3YRADH",
  "DLENS20K3YRADH",
  "DKIT10002YR",
  "DKIT12502YR",
  "DKIT15002YR",
  "DKIT20002YR",
  "DKIT25002YR",
  "DKIT30002YR",
  "DKIT35002YR",
  "DKIT40002YR",
  "DKIT45002YR",
  "DKIT50002YR",
  "DKIT60002YR",
  "DKIT70002YR",
  "DKIT80002YR",
  "DKIT90002YR",
  "DKIT10K2YR",
  "DKIT10002YRADH",
  "DKIT12502YRADH",
  "DKIT15002YRADH",
  "DKIT20002YRADH",
  "DKIT25002YRADH",
  "DKIT30002YRADH",
  "DKIT35002YRADH",
  "DKIT40002YRADH",
  "DKIT45002YRADH",
  "DKIT50002YRADH",
  "DKIT60002YRADH",
  "DKIT70002YRADH",
  "DKIT80002YRADH",
  "DKIT90002YRADH",
  "DKIT10K2YRADH",
  "DKIT10003YR",
  "DKIT12503YR",
  "DKIT15003YR",
  "DKIT20003YR",
  "DKIT25003YR",
  "DKIT30003YR",
  "DKIT35003YR",
  "DKIT40003YR",
  "DKIT45003YR",
  "DKIT50003YR",
  "DKIT60003YR",
  "DKIT70003YR",
  "DKIT80003YR",
  "DKIT90003YR",
  "DKIT10K3YR",
  "DKIT10003YRADH",
  "DKIT12503YRADH",
  "DKIT15003YRADH",
  "DKIT20003YRADH",
  "DKIT25003YRADH",
  "DKIT30003YRADH",
  "DKIT35003YRADH",
  "DKIT40003YRADH",
  "DKIT45003YRADH",
  "DKIT50003YRADH",
  "DKIT60003YRADH",
  "DKIT70003YRADH",
  "DKIT80003YRADH",
  "DKIT90003YRADH",
  "DKIT10K3YRADH",
  "DPS5002YR",
  "DPS7502YR",
  "DPS10002YR",
  "DPS12502YR",
  "DPS15002YR",
  "DPS20002YR",
  "DPS5002YRADH",
  "DPS7502YRADH",
  "DPS10002YRADH",
  "DPS12502YRADH",
  "DPS15002YRADH",
  "DPS20002YRADH",
  "DPS5003YR",
  "DPS7503YR",
  "DPS10003YR",
  "DPS12503YR",
  "DPS15003YR",
  "DPS20003YR",
  "DPS5003YRADH",
  "DPS7503YRADH",
  "DPS10003YRADH",
  "DPS12503YRADH",
  "DPS15003YRADH",
  "DPS20003YRADH",
  "DACC3002YR",
  "DACC4002YR",
  "DACC5002YR",
  "DACC7502YR",
  "DACC10002YR",
  "DACC12502YR",
  "DACC15002YR",
  "DACC20002YR",
  "DACC3002YRADH",
  "DACC4002YRADH",
  "DACC5002YRADH",
  "DACC7502YRADH",
  "DACC10002YRADH",
  "DACC12502YRADH",
  "DACC15002YRADH",
  "DACC20002YRADH",
  "DACC3003YR",
  "DACC4003YR",
  "DACC5003YR",
  "DACC7503YR",
  "DACC10003YR",
  "DACC12503YR",
  "DACC15003YR",
  "DACC20003YR",
  "DACC3003YRADH",
  "DACC4003YRADH",
  "DACC5003YRADH",
  "DACC7503YRADH",
  "DACC10003YRADH",
  "DACC12503YRADH",
  "DACC15003YRADH",
  "DACC20003YRADH",
];
